import React from 'react'

import DownArrowIcon from '../icon/DownArrow'

const ScrollDownButton = () => (
  <div className="cursor-pointer text-white hover:text-orange _transition-all">
    <DownArrowIcon className="stroke-current" stroke="" />
  </div>
)

export default ScrollDownButton
